export default (theme) => ({
  container: {
    padding: 5,
  },
  textField: {
    width: "100%",
  },
});
